export enum SftpServerValidation {
  None = 'validation-none',
  PublicKey = 'validation-public-key'
}
